export const CONSTANTS = {
  euroTlParitesi: 38,
  dgazEnerjisi: 8250,
  kazanVerimi: 0.92,
  co2Factor: 2.34
};

export const EQUIPMENT_TYPES = [
  { id: 'chiller', name: 'Chiller', imgSrc: '/icons/chiller.png', description: 'Soğutma Sistemi' },
  //{ id: 'boiler', name: 'Kazan', imgSrc: '/icons/atik_isi.png', description: 'Isıtma Sistemi' },
  { id: 'heatRecovery', name: 'Atık Isı', imgSrc: '/icons/waste-heat.png', description: 'Atık Isı Geri Kazanımı' },
  { id: 'coolingTower', name: 'Soğutma Kulesi', imgSrc: '/icons/cooling-tower.png', description: 'Soğutma Kulesi' }
];

// Kullanıcı ekipmanları (kaynakları kullanan ekipmanlar) - güncellenmiş liste
export const CLIENT_EQUIPMENT_TYPES = [
  { id: 'boiler', name: 'Sıcak Su Kazanı', imgSrc: '/icons/boiler.png', description: 'Isıtma Sistemi' },
  { id: 'airHandler', name: 'Klima Santrali', imgSrc: '/icons/air3.png', description: 'Isıtma Sistemi' },
  { id: 'radiator', name: 'Radyatör', imgSrc: '/icons/rad.png', description: 'Isıtma Sistemi' }
];

export const DEFAULT_PARAMS = {
  workingHours: 8760,
  electricityPrice: 4,
  gasPrice: 12,
  baseCOP: 3.5
};